<template>
  <add-edit-dialog>
    <crm-panel title="编辑字典配置">
      <div class="page-buttons">
        <crm-button
          :text="'保存'"
          @click="handleUpdateDictionary()">
        </crm-button>
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="cancelUpdateDictionary()">
        </crm-button>
      </div>
      <el-form
        label-width="140px"
        class="clearfix add-edit-form"
        :rules="updateRules"
        ref="updateForm"
        :model="updateForm"
        v-loading="loading">
        <el-col :span="12" :offset="5">
          <el-form-item label="二级团队：" prop="teamId">
            <el-select clearable v-model="updateForm.teamId" disabled>
              <el-option
                v-for="item in secondTeamList.data"
                :label="item.name"
                :value="item.teamId"
                :key="item.uid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="5">
          <el-form-item label="字典名称：" prop="categoryId">
            <el-select clearable v-model="updateForm.categoryId" @change="handleCategoryChange" disabled>
              <el-option
                v-for="item in categoryList.data"
                :label="item.name"
                :value="item.uid"
                :key="item.uid">
              </el-option>
              <el-option
                v-if="allCategoryList.totalCount > categoryList.pageSize &&
                  allCategoryList.totalPages > categoryList.pageNumber"
                label="点击加载更多"
                value="点击加载更多"
                :disabled="true"
                style="cursor:pointer;">
                <span @click="handleMoreCategoryList()">点击加载更多</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="5">
          <el-form-item label="字典项名称：" prop="dictionary" class="select-dictionary">
            <el-select clearable multiple v-model="updateForm.dictionary" @remove-tag="handleDictionaryRemove" style="width: 100%">
              <el-option
                v-for="item in dictionaryList.data"
                :label="item.name"
                :value="item.uid"
                :key="item.uid">
              </el-option>
              <el-option
                v-if="allDictionaryList.totalCount > dictionaryList.pageSize &&
                  allDictionaryList.totalPages > dictionaryList.pageNumber &&
                  dictionaryList.data.length !== 0"
                label="点击加载更多"
                value="点击加载更多"
                :disabled="true"
                style="cursor:pointer;">
                <span @click="handleMoreDictionaryList()">点击加载更多</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddEditDialog from '@/components/base/addEditDialog';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';

export default {
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      updateForm: {
        id: '',
        teamId: '',
        teamName: '',
        categoryId: '',
        categoryName: '',
        dictionary: [],
        addDetail: [],
        delDetail: [],
      },
      updateRules: {
        teamId: [
          { required: true, message: '请选择二级团队', trigger: 'change' },
        ],
        categoryId: [
          { required: true, message: '请选择字典名称', trigger: 'change' },
        ],
        dictionary: [
          { required: true, message: '请选择字典项名称', trigger: 'change' },
        ],
      },
      categoryList: {
        data: [],
        pageNumber: 1,
        pageSize: 100,
      },
      dictionaryList: {
        data: [],
        pageNumber: 1,
        pageSize: 100,
        code: '',
      },
      isSubmitDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      secondTeamList: 'backstage/secondTeamList',
      allCategoryList: 'backstage/allCategoryList',
      allDictionaryList: 'backstage/allDictionaryList',
      teamConfigDetail: 'backstage/teamConfigDetail',
    }),
  },
  created() {
    this.loading = true;
    this.getSecondTeamList();
    Promise.all([
      this.handleGetDetail(),
      this.handleGetAllCategoryList(),
    ]).then(() => {
      this.dictionaryList.code = this.categoryList.data.find(item =>
        item.uid === this.teamConfigDetail.categoryId).code;
      this.handleGetAllDictionaryList().finally(() => {
        this.loading = false;
      });
    });
  },
  methods: {
    ...mapActions({
      getSecondTeamList: 'backstage/getSecondTeamList',
      getAllCategoryList: 'backstage/getAllCategoryList',
      getAllDictionaryList: 'backstage/getAllDictionaryList',
      getTeamConfigDetail: 'backstage/getTeamConfigDetail',
      saveUpdateTeamConfig: 'backstage/saveUpdateTeamConfig',
    }),
    handleGetDetail() {
      return new Promise((resolve, reject) => {
        this.getTeamConfigDetail({ id: this.id }).then(() => {
          this.updateForm = {
            id: this.id,
            teamId: this.teamConfigDetail.teamId,
            teamName: this.teamConfigDetail.teamName,
            categoryId: this.teamConfigDetail.categoryId,
            categoryName: this.teamConfigDetail.categoryName,
            dictionary: [],
            addDetail: [],
            delDetail: [],
          };
          this.teamConfigDetail.detailVOS.forEach((item) => {
            this.updateForm.dictionary.push(item.dictId);
          });
          resolve();
        }).catch((err) => {
          reject(err);
        });
      });
    },
    cancelUpdateDictionary() {
      this.$emit('close');
    },
    handleUpdateDictionary() {
      this.$refs.updateForm.validate((valid) => {
        if (valid) {
          this.isSubmitDisabled = true;
          this.updateForm.teamName = this.secondTeamList.data.find(item =>
            item.teamId === this.updateForm.teamId).name;
          this.updateForm.categoryName = this.categoryList.data.find(item =>
            item.uid === this.updateForm.categoryId).name;
          this.updateForm.dictionary.forEach((item) => {
            if (!this.teamConfigDetail.detailVOS.find(i => i.dictId === item)) {
              const updateItem = this.dictionaryList.data.find(i =>
                i.uid === item);
              this.updateForm.addDetail.push({
                dictId: updateItem.uid,
                dictName: updateItem.name,
              });
            }
          });
          this.teamConfigDetail.detailVOS.forEach((item) => {
            if (!this.updateForm.dictionary.find(i => i === item.dictId)) {
              this.updateForm.delDetail.push({
                id: item.id,
                dictId: item.dictId,
                dictName: item.dictName,
              });
            }
          });
          const { dictionary, ...params } = this.updateForm;
          this.saveUpdateTeamConfig({
            ...params,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '修改成功',
            });
            this.$emit('close');
            this.$emit('success');
          }).finally(() => { this.isSubmitDisabled = false; });
        }
      });
    },
    handleCategoryChange(value) {
      this.dictionaryList.pageNumber = 1;
      if (value) {
        this.dictionaryList.code = this.categoryList.data.find(item => item.uid === value).code;
        this.handleGetAllDictionaryList();
      } else {
        this.dictionaryList.data = [];
        this.updateForm.dictionary = [];
      }
    },
    handleGetAllCategoryList() {
      return new Promise((resolve, reject) => {
        this.getAllCategoryList({
          pageNumber: this.categoryList.pageNumber,
          pageSize: this.categoryList.pageSize,
        }).then(() => {
          if (this.categoryList.pageNumber === 1) {
            this.categoryList.data = [];
          }
          this.allCategoryList.results.forEach((item) => {
            this.categoryList.data.push(item);
          });
          resolve();
        }).catch((err) => {
          reject(err);
        });
      });
    },
    handleMoreCategoryList() {
      this.categoryList.pageNumber += 1;
      this.handleGetAllCategoryList();
    },
    handleGetAllDictionaryList() {
      return new Promise((resolve, reject) => {
        this.getAllDictionaryList({
          pageNumber: this.dictionaryList.pageNumber,
          pageSize: this.dictionaryList.pageSize,
          code: this.dictionaryList.code,
        }).then(() => {
          if (this.dictionaryList.pageNumber === 1) {
            this.dictionaryList.data = [];
          }
          this.allDictionaryList.results.forEach((item) => {
            this.dictionaryList.data.push(item);
          });
          resolve();
        }).catch((err) => {
          reject(err);
        });
      });
    },
    handleMoreDictionaryList() {
      this.dictionaryList.pageNumber += 1;
      this.handleGetAllDictionaryList();
    },
    handleDictionaryRemove(value) {
      // this.teamConfigDetail.detailVOS.forEach((item) => {
      //   if (value === item.dictId) {
      //     this.updateForm.delDetail.push({
      //       id: item.id,
      //       dictId: item.dictId,
      //       dictName: item.dictName,
      //     });
      //   }
      // });
    },
  },
};
</script>

<style lang="less">
.dialog-update-teamconfig {
  padding-right: 30px;
  .dialog-footer{
    text-align: right;
  }
  .el-date-editor.el-input{
    width: 100%;
  }
  .select-dictionary{
    .el-select{
      width: 100%;
    }
  }
}
</style>
